import { cooperationRoutes } from "./cooperation-routes";

export default (router: any) => {
  cooperationRoutes.forEach((route: any) => {
    router.addRoute(route);
  });
};
